import moment from "moment";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import CardBasic from "../components/CardBasic";
import ModalLoading from "../components/ModalLoading";
import { getDataAxios, logger } from "../utils/Utils";
import V2MigrationBanner from "../components/Banner/V2MigrationBanner";

export default function HomeFragment() {
  const user = JSON.parse(localStorage.getItem("dompet_user"));
  const dataOutlet = JSON.parse(localStorage.getItem("dompet_detail_outlet"));

  const [voucherActive, setVoucherActive] = useState([]);
  const [showModalLoading, setShowModalLoading] = useState(false);
  useEffect(() => {
    if (user) {
      getData();
    } else {
      logger("Not Login");
    }
    return () => {};
  }, []);

  async function getData() {
    // show modal loading until data loaded
    setShowModalLoading(true);
    try {
      // get list voucher active
      let res_voucher_active = await getDataAxios(
        `${process.env.REACT_APP_BASE_URL_API}/v2/project/voucher/imageList?channel_id=${dataOutlet.channel_id}`,
      );
      setVoucherActive(res_voucher_active.data.data);
    } catch (error) {
      console.error(error);
    }
    // hide modal loading after data is loaded
    setShowModalLoading(false);
  }

  const SliderVoucher = () => (
    <Slider
      dots={true}
      infinite={true}
      autoplay={true}
      autoplaySpeed={4000}
      speed={500}
      slidesToShow={1}
      slidesToScroll={1}
      className="mt-3 mb-10"
    >
      {voucherActive.map((voucher, i) => (
        <div key={i} className="bg-white px-2 py-2">
          {voucher.image_voucher ? (
            <img
              className="max-h-48 w-full object-cover object-center"
              src={voucher.image_voucher}
              alt={voucher.voucher_name}
            />
          ) : (
            <div className="flex h-48 items-center justify-center bg-gray-100">
              Voucher image not available
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="ml-2 h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
                />
              </svg>
            </div>
          )}
        </div>
      ))}
    </Slider>
  );

  return (
    <>
      {/* <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
         /> */}
      <div className="space-y-5">
        <V2MigrationBanner />
        {/* Accounts Detail */}
        <CardBasic title="Accounts Detail">
          <div className="px-5 py-4">
            <div className="space-y-3">
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Account Name
                </div>
                <p className="text-gray-500">
                  {dataOutlet.channel_sub_sub_category ?? "-"}
                </p>
              </div>
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Outlet Name
                </div>
                <p className="text-gray-500">
                  {dataOutlet.outlet_kartini_name ?? "-"}
                </p>
              </div>
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Outlet Address
                </div>
                <p className="text-gray-500">{dataOutlet.address ?? "-"}</p>
              </div>
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Account Owner
                </div>
                <p className="text-gray-500">
                  {dataOutlet.contact_person ?? "-"}
                </p>
              </div>
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Outlet Admin
                </div>
                <p className="text-gray-500">{dataOutlet.admin ?? "-"}</p>
              </div>
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Outlet User
                </div>
                <p className="text-gray-500">{user.user_name ?? "-"}</p>
              </div>
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Mitra Start Date
                </div>
                <p className="text-gray-500">
                  {dataOutlet.created_at
                    ? moment(dataOutlet.created_at).format("DD-MM-YYYY")
                    : "-"}
                </p>
              </div>
              <div className="text-sm">
                <div className="mb-1 font-medium text-gray-700">
                  Mitra Status
                </div>
                {}
                <div
                  className={`inline-flex text-xs font-medium ${
                    dataOutlet.status === "active"
                      ? "bg-green-100 text-green-600"
                      : "bg-red-100 text-red-600"
                  } rounded-full px-2.5 py-1 text-center`}
                >
                  {dataOutlet.status ?? "-"}
                </div>
              </div>
            </div>
          </div>
        </CardBasic>
        <div className="pb-10">
          <CardBasic title="Active Voucher(s)">
            <div>
              {voucherActive.length > 0 ? (
                <SliderVoucher />
              ) : (
                <p className="mt-5 text-center text-gray-700">
                  No Active Vouchers
                </p>
              )}
            </div>
          </CardBasic>
        </div>
      </div>
    </>
  );
}
